module.exports = __webpack_public_path__ + "static/media/MenuCookies.10accfa7.jpg";